export default class Contact {
	id: number;     	//ид
	city: string;		//город
	company: string;    //название компании
	position: string;    //должность
	fullname: string;	//фио
	phoneNumber: string;//номер телефона
	comment: string;	//комментарий
}